import React from "react";
import PropTypes from "prop-types";
import usePortfolioStyles from "./portfolio-style";
import CorpSubsidiary from "./corp-subsidiary";
import PolicyIconMedical from '../../assets/policyDetails/Icon-medical.svg';
import QnectButton from "../qnect-ui/qnect-button";
import FieldWrapper from "../custom/field-wrapper";
import getFormattedDateRange from "../../utils/formatted-date-range";

const CorpPolicy = ({policy, policyIndex, canSubmit, onSubmit, onCancel, submitMessage, props, cfg}) => {
    const classes = usePortfolioStyles(props);

    const getPeriod = () => {
        return getFormattedDateRange(policy.inceptionDate, policy.expiryDate);
    }

    return (<>
        <div className={classes.policy_card}>
            <div className={classes.policy_details}>
                <div className={classes.policy_number_details}>
                    <img src={PolicyIconMedical} height="46" alt="Medical Policy" />
                    <div>
                        <span>Group Medical</span>
                        <span>{policy.policyNumber}</span>
                        <span>{policy.clientName}</span>
                    </div>
                </div>
                <div className={classes.policy_date_status}>
                    <div className={classes.policy_titles}>Policy Period</div>
                    <div className={classes.policy_date}>{getPeriod()}</div>
                    <div className='policy_status status_active'>{cfg('policyStatus', policy.status)}</div>
                </div>
            </div>

            <div className={classes.subsidiary_plan_cards}>
                {
                    policy.subsidiaryList.length > 0 && policy.subsidiaryList.map((subs, index) => {
                        return <CorpSubsidiary policyDetail={policy} subsidiary={subs} subsidiaryIndex={index} props={props} policyIndex={policyIndex}></CorpSubsidiary>
                    })
                }
            </div>

            {
                canSubmit &&
            <div className="action_buttons_container">
                <FieldWrapper>
                    <QnectButton field="cancelChange" onClick={onCancel}/>
                    <QnectButton field="submitChange" onClick={onSubmit}/>
                </FieldWrapper>
            </div>
            }
            {
                submitMessage && submitMessage.type === 'INFO' &&
                <div className="action_buttons_container">
                    <div className="messageDiv">{submitMessage.message}</div>
                </div>
            }
            {
                submitMessage && submitMessage.type === 'ERROR' &&
                <div className="action_buttons_container">
                    <div className="errorMessageDiv">{submitMessage.message}</div>
                </div>
            }
        </div>
    </>);
}

CorpPolicy.propTypes = {
    policy: PropTypes.object,
    submitMessage: PropTypes.object,
    onClick: PropTypes.func,
    onCancel: PropTypes.func
};

export default CorpPolicy;